import { Box, useTheme } from '@mui/material'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { useContext } from 'react'

import { AppSettingsContext } from '../Contexts'
import { getCroppedMapUrl, getStaticMapUrl } from '../getCroppedMapUrl'

interface Props {
  crop?: boolean
  imgSize?: string | number
  quadkey?: Quadkey
  size?: number
}

const QuadkeyMap: React.FC<Props> = (props) => {
  const quadkey = props.quadkey ?? new Quadkey()
  const { crop = false, size = 320, imgSize } = props
  const theme = useTheme()
  const { mapStyle } = useContext(AppSettingsContext)

  let boundingBox
  if (crop) {
    boundingBox = { height: 0, left: 0, top: 0, width: 0 }
  } else {
    boundingBox = quadkey.getGridBoundingBox(size)
  }

  return (
    <Box
      height={imgSize ?? size}
      position="relative"
      style={{
        backgroundAttachment: 'cover',
        backgroundImage: `url(${crop ? getCroppedMapUrl(quadkey, mapStyle, size) : getStaticMapUrl(mapStyle)})`,
        backgroundPosition: 'center',
        backgroundRepeat: 'none',
        backgroundSize: 'cover',
      }}
      width={imgSize ?? size}
    >
      {crop ? null : <div style={{ backgroundColor: theme.palette.primary.main, opacity: 0.5, position: 'absolute', ...boundingBox }} />}
    </Box>
  )
}

export default QuadkeyMap
